import { jsx as t } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as m, useCallback as d, useState as P } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { isCapitalRegionSupported as U } from "../../../../internal/CapitalHeader/helpers.js";
import { CapitalErrorMessageDisplay as Q } from "../../../CapitalOffer/components/utils/CapitalErrorMessageDisplay.js";
import { CAPITAL_OVERVIEW_CLASS_NAMES as i } from "../../constants.js";
import { useFetch as R } from "../../../../../hooks/useFetch.js";
/* empty css                     */
import _ from "../Unqualified.js";
import { PreQualified as k } from "../PreQualified/PreQualified.js";
import { GrantList as D } from "../GrantList/GrantList.js";
import { ErrorMessageDisplay as I } from "../../../../internal/ErrorMessageDisplay/ErrorMessageDisplay.js";
import { getCapitalErrorMessage as K } from "../../../../utils/capital/getCapitalErrorMessage.js";
import { useConfigContext as x } from "../../../../../core/ConfigContext/context.js";
import { CapitalHeader as G } from "../../../../internal/CapitalHeader/CapitalHeader.js";
import { EMPTY_OBJECT as N } from "../../../../../utils/value/constants.js";
const te = ({
  hideTitle: u,
  onContactSupport: g,
  onFundsRequest: f,
  onOfferDismiss: h,
  onOfferOptionsRequest: M,
  skipPreQualifiedIntro: C
}) => {
  var q, v, A;
  const y = (v = (q = x()) == null ? void 0 : q.extraConfig) == null ? void 0 : v.legalEntity, c = m(() => U(y), [y]), { getGrants: s, getDynamicGrantOffersConfiguration: o } = x().endpoints, n = R({
    fetchOptions: { enabled: !!s && c },
    queryFn: d(async () => s == null ? void 0 : s(N), [])
  }), a = R({
    fetchOptions: { enabled: !!o && c },
    queryFn: d(async () => o == null ? void 0 : o(N), [])
  }), e = a.data, [p, S] = P(), r = m(
    () => {
      var l, b;
      return p ? [p, ...((l = n.data) == null ? void 0 : l.data) || []] : (b = n.data) == null ? void 0 : b.data;
    },
    [(A = n.data) == null ? void 0 : A.data, p]
  ), E = d(
    (l) => {
      f ? f(l) : S(l);
    },
    [f]
  ), F = m(() => !!(a.error && n.error || a.error && !(r != null && r.length)), [a.error, r == null ? void 0 : r.length, n.error]), w = m(() => {
    if (c) {
      if (F)
        return "Error";
      if (!s && !o || !e && !r || n.isFetching || a.isFetching)
        return "Loading";
      if (r != null && r.length)
        return "GrantList";
      if (e != null && e.maxAmount && (e != null && e.minAmount))
        return "PreQualified";
    } else return "UnsupportedRegion";
    return "Unqualified";
  }, [
    o,
    e,
    a.isFetching,
    r,
    s,
    n.isFetching,
    F,
    C,
    c
  ]), O = m(() => !!(e && e.minAmount && e.maxAmount), [e]);
  return /* @__PURE__ */ t("div", { className: i.base, children: (() => {
    switch (w) {
      case "Loading":
        return /* @__PURE__ */ t("div", { className: i.skeletonContainer, children: [
          /* @__PURE__ */ t("div", { className: i.headerSkeleton }),
          /* @__PURE__ */ t("div", { className: i.skeleton })
        ] });
      case "Error":
        return /* @__PURE__ */ t("div", { className: i.errorContainer, children: [
          /* @__PURE__ */ t(G, { hideTitle: u, titleKey: "capital.businessFinancing" }),
          /* @__PURE__ */ t(
            I,
            {
              absolutePosition: !1,
              outlined: !1,
              withImage: !0,
              onContactSupport: g,
              ...K(a.error, g)
            }
          )
        ] });
      case "GrantList":
        return r && /* @__PURE__ */ t(
          D,
          {
            externalDynamicOffersConfig: e,
            grantList: r,
            hideTitle: u,
            newOfferAvailable: O,
            onFundsRequest: E,
            onOfferDismiss: h
          }
        );
      case "PreQualified":
        return /* @__PURE__ */ t(
          k,
          {
            onOfferDismiss: h,
            onOfferOptionsRequest: M,
            skipPreQualifiedIntro: C,
            hideTitle: u,
            dynamicOffer: e,
            onFundsRequest: E
          }
        );
      case "Unqualified":
        return /* @__PURE__ */ t(_, { hideTitle: u });
      case "UnsupportedRegion":
        return /* @__PURE__ */ t("div", { className: i.errorContainer, children: [
          /* @__PURE__ */ t(G, { hideTitle: u, titleKey: "capital.businessFinancing" }),
          /* @__PURE__ */ t(Q, { unsupportedRegion: !0 })
        ] });
      default:
        return null;
    }
  })() });
};
export {
  te as CapitalOverview
};
